
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { TreeStructure } from "@gsx/common";
import { Container } from "inversify";

@Component
export default class CountryTreeNode extends Vue {
    @Prop() value!: TreeStructure;
    @Prop() toggle!: (name: string) => void;
    @Prop() filterStore!: any;
    @Inject("container") container!: Container;
    active: boolean = false;

    get hasChildren(): boolean {
        return Array.isArray(this.value.children) && this.value.children.length > 0;
    }

    get checked(): boolean {
        let [type] = this.value.id.split(":");
        if (type === "country") {
            return this.filterStore.countries.has(this.value.id);
        } else if (type === "state") {
            return this.filterStore.states.has(this.value.id);
        } else if (type === "city") {
            return this.filterStore.cities.has(this.value.id);
        }
        return false;
    }

    toggleActive(): void {
        this.active = !this.active;
    }

    updateChecked(e: any): void {
        let [type] = this.value.id.split(":");
        if (e.target.checked !== this.checked) {
            if (type === "country") {
                this.filterStore.toggleCountry(this.value.id);
            } else if (type === "state") {
                this.filterStore.toggleState(this.value.id);
            } else if (type === "city") {
                this.filterStore.toggleCity(this.value.id);
            }
        }
    }
}
